import React, { useCallback, useState, useEffect, useMemo, useContext } from 'react';

import { useLocalizedStrings, LocalizationContext } from 'app/localization/Context';
import ThermostatWheel from './ThermostatWheel';
import { HinavaEcoThermostatInfo, MarsusInfo, SednaInfo } from 'app/model/Device';

import { ReactComponent as IconModeFan } from 'images/device/thermostat/device_detail/mode_fan.svg';
import { ReactComponent as IconModeCooling } from 'images/device/thermostat/device_detail/mode_cooling.svg';
import { ReactComponent as IconModeHeating } from 'images/device/thermostat/device_detail/mode_heating.svg';
import { ReactComponent as IconModeEco } from 'images/device/thermostat/device_detail/mode_eco.svg';
import { ReactComponent as IconModeManual } from 'images/device/thermostat/device_detail/mode_manual.svg';
import { ReactComponent as IconModeAuto } from 'images/device/thermostat/device_detail/mode_auto.svg';
import { ReactComponent as IconModeAntiFreeze } from 'images/device/thermostat/device_detail/mode_antifreeze.svg';
import { ReactComponent as IconScenarioLeave } from 'images/device/thermostat/device_detail/scenario_leave.svg';
import { ReactComponent as IconScenarioManual } from 'images/device/thermostat/device_detail/scenario_manual.svg';
import { ReactComponent as IconScenarioSleep } from 'images/device/thermostat/device_detail/scenario_sleep.svg';
import { ReactComponent as IconScenarioTurbo } from 'images/device/thermostat/device_detail/scenario_turbo.svg';
import { ReactComponent as IconHinavaTurbo } from 'images/device/thermostat/device_detail/hinava_turbo.svg';
import { ReactComponent as IconPumpOn } from 'images/device/thermostat/device_detail/pump_on.svg';
import { ReactComponent as IconPumpOff } from 'images/device/thermostat/device_detail/pump_off.svg';
import { ReactComponent as IconSpeedAuto } from 'images/device/thermostat/device_detail/speed_auto.svg';
import { ReactComponent as IconSpeedFast } from 'images/device/thermostat/device_detail/speed_fast.svg';
import { ReactComponent as IconSpeedMedium } from 'images/device/thermostat/device_detail/speed_medium.svg';
import { ReactComponent as IconSpeedSlow } from 'images/device/thermostat/device_detail/speed_slow.svg';
import { ReactComponent as IconSpeedOff } from 'images/device/thermostat/device_detail/speed_off.svg';

import { ReactComponent as IconModeFanBlack } from 'images/device/thermostat/device_detail_black/mode_fan.svg';
import { ReactComponent as IconModeCoolingBlack } from 'images/device/thermostat/device_detail_black/mode_cooling.svg';
import { ReactComponent as IconModeHeatingBlack } from 'images/device/thermostat/device_detail_black/mode_heating.svg';
import { ReactComponent as IconModeEcoBlack } from 'images/device/thermostat/device_detail_black/mode_eco.svg';
import { ReactComponent as IconModeManualBlack } from 'images/device/thermostat/device_detail_black/mode_manual.svg';
import { ReactComponent as IconModeAutoBlack } from 'images/device/thermostat/device_detail_black/mode_auto.svg';
import { ReactComponent as IconModeAntiFreezeBlack } from 'images/device/thermostat/device_detail_black/mode_antifreeze.svg';
import { ReactComponent as IconScenarioLeaveBlack } from 'images/device/thermostat/device_detail_black/scenario_leave.svg';
import { ReactComponent as IconScenarioManualBlack } from 'images/device/thermostat/device_detail_black/scenario_manual.svg';
import { ReactComponent as IconScenarioSleepBlack } from 'images/device/thermostat/device_detail_black/scenario_sleep.svg';
import { ReactComponent as IconScenarioTurboBlack } from 'images/device/thermostat/device_detail_black/scenario_turbo.svg';
import { ReactComponent as IconHinavaTurboBlack } from 'images/device/thermostat/device_detail_black/hinava_turbo.svg';
import { ReactComponent as IconPumpOnBlack } from 'images/device/thermostat/device_detail_black/pump_on.svg';
import { ReactComponent as IconPumpOffBlack } from 'images/device/thermostat/device_detail_black/pump_off.svg';
import { ReactComponent as IconSpeedAutoBlack } from 'images/device/thermostat/device_detail_black/speed_auto.svg';
import { ReactComponent as IconSpeedFastBlack } from 'images/device/thermostat/device_detail_black/speed_fast.svg';
import { ReactComponent as IconSpeedMediumBlack } from 'images/device/thermostat/device_detail_black/speed_medium.svg';
import { ReactComponent as IconSpeedSlowBlack } from 'images/device/thermostat/device_detail_black/speed_slow.svg';
import { ReactComponent as IconSpeedOffBlack } from 'images/device/thermostat/device_detail_black/speed_off.svg';

import { ReactComponent as IconScenarioLeaveGray } from 'images/device/thermostat/device_detail_gray/scenario_leave.svg';
import { ReactComponent as IconScenarioManualGray } from 'images/device/thermostat/device_detail_gray/scenario_manual.svg';
import { ReactComponent as IconScenarioSleepGray } from 'images/device/thermostat/device_detail_gray/scenario_sleep.svg';
import { ReactComponent as IconScenarioTurboGray } from 'images/device/thermostat/device_detail_gray/scenario_turbo.svg';
import { ReactComponent as IconHinavaTurboGray } from 'images/device/thermostat/device_detail_gray/hinava_turbo.svg';
import { ReactComponent as IconPumpOnGray } from 'images/device/thermostat/device_detail_gray/pump_on.svg';
import { ReactComponent as IconPumpOffGray } from 'images/device/thermostat/device_detail_gray/pump_off.svg';
import { ReactComponent as IconSpeedAutoGray } from 'images/device/thermostat/device_detail_gray/speed_auto.svg';
import { ReactComponent as IconSpeedFastGray } from 'images/device/thermostat/device_detail_gray/speed_fast.svg';
import { ReactComponent as IconSpeedMediumGray } from 'images/device/thermostat/device_detail_gray/speed_medium.svg';
import { ReactComponent as IconSpeedSlowGray } from 'images/device/thermostat/device_detail_gray/speed_slow.svg';
import { ReactComponent as IconSpeedOffGray } from 'images/device/thermostat/device_detail_gray/speed_off.svg';
import { ReactComponent as IconSednaEconomyGray } from 'images/device/thermostat/device_detail_gray/sedna_economy.svg';
import { ReactComponent as IconHinavaEconomyGray } from 'images/device/thermostat/device_detail_gray/hinava_eco.svg';

import { ReactComponent as IconStatusON } from 'images/device/status-text-icon/on.svg';
import { ReactComponent as IconStatusONFa } from 'images/device/status-text-icon/on-fa.svg';
import { ReactComponent as IconStatusONAr } from 'images/device/status-text-icon/on-ar.svg';
// import { ReactComponent as IconOff } from 'images/device/thermostat/off.svg';
import { ReactComponent as IconOn } from 'images/device/thermostat/on.svg';
import { ReactComponent as IconOnWhite } from 'images/device/thermostat/on-white.svg';
import { ReactComponent as IconOnBlack } from 'images/device/thermostat/on-black.svg';
import { ReactComponent as IconPlus } from 'images/device/thermostat/plus.svg';
import { ReactComponent as IconMinus } from 'images/device/thermostat/minus.svg';

import { ReactComponent as IconThreeDotsLoadingGray } from 'images/general/three-dots-loading-gray.svg';
import { ReactComponent as IconThreeDotsLoadingGradient } from 'images/general/three-dots-loading-gradient.svg';

import "./ThermostatControl.scss"

export function ThermostatOnOff({ device }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;

    let onLabel = null;
    if (l.language === 'en') {
        onLabel = <IconStatusON />;
    } else if (l.language === 'fa') {
        onLabel = <IconStatusONFa />;
    } else if (l.language === 'ar') {
        onLabel = <IconStatusONAr />;
    }

    const onClickH = useCallback((on) => {
        return (event) => {
            event.preventDefault();
            device.changeState({ is_on: on });
        }
    }, [device]);


    if (!device.is_on) {
        onLabel = <div className="off-label">{s.off}</div>;
    }

    const shouldShowWaiting = device.waitingForChangeState["is_on"] &&
        !device.waitingForChangeState["is_on"].ignoreWaiting;
    if (shouldShowWaiting) {
        if (device.is_on) {
            onLabel = <IconThreeDotsLoadingGradient className="dots-icon" />;
        } else {
            onLabel = <IconThreeDotsLoadingGray className="dots-icon" />;
        }
    }

    if (device.active) {
        if (device.is_on) {
            return (
                <div className="thermostat-on-off-button" onClick={onClickH(false)}>
                    <IconOn className="icon" />
                    {onLabel}
                </div>
            );
        } else {
            return null;
            // return (
            //     <div className="thermostat-on-off-button" onClick={onClickH(true)}>
            //         <IconOff className="icon" />
            //         {onLabel}
            //     </div>
            // );
        }
    } else {
        return null;
    }
}

function useSedna(device) {
    const se = useLocalizedStrings().sedna;

    const modeState = [
        device.mode === SednaInfo.mode.heating,
        device.mode === SednaInfo.mode.cooling
    ]
    const motorSpeedState = [
        device.motor_speed === SednaInfo.motorSpeed.high,
        device.motor_speed === SednaInfo.motorSpeed.medium,
        device.motor_speed === SednaInfo.motorSpeed.low,
        device.motor_speed === SednaInfo.motorSpeed.auto,
    ]
    const scenarioState = [
        device.scenario === SednaInfo.scenario.turbo,
        device.scenario === SednaInfo.scenario.sleep,
        device.scenario === SednaInfo.scenario.away,
        device.scenario === SednaInfo.scenario.manual,
    ]
    const mode_enable = device.mode_enable && device.is_on && device.active;
    const motor_speed_enable = device.motor_speed_enable && device.is_on && device.active;
    const scenario_enable = device.scenario_enable && device.is_on && device.active;

    const onModeClickH = useCallback((mode) => {
        return (event) => {
            event.preventDefault();
            if (mode_enable)
                device.changeState({ mode: mode, sub_type: SednaInfo.subType.volkan });
        }
    }, [mode_enable, device]);

    const onMotorSpeedClickH = useCallback((motorSpeed) => {
        return (event) => {
            event.preventDefault();
            if (motor_speed_enable)
                device.changeState({ motor_speed: motorSpeed, sub_type: SednaInfo.subType.volkan });
        }
    }, [motor_speed_enable, device]);

    const onScenarioClickH = useCallback((scenario) => {
        return (event) => {
            event.preventDefault();
            if (scenario_enable)
                device.changeState({ scenario: scenario, sub_type: SednaInfo.subType.volkan });
        }
    }, [scenario_enable, device]);

    const [targetTemperature, setTempTargetTemperature] = useState(device.set_point);
    useEffect(() => {
        setTempTargetTemperature(device.set_point);
    }, [device.set_point]);
    const setTargetTemperature = useCallback((v) => {
        let newValue = Number(v.toFixed(1));
        if ((device.set_point_min !== undefined) && (device.set_point_max !== undefined)) {
            newValue = Math.max(device.set_point_min, Math.min(device.set_point_max, newValue));
        }
        setTempTargetTemperature(newValue);
        device.changeState({ set_point: newValue, sub_type: SednaInfo.subType.volkan });
    }, [device]);

    const showTemperatures = device.active && device.is_on;
    const showSetpoint = showTemperatures;
    const targetTemperatureToShow = useMemo(() => {
        if (showTemperatures && targetTemperature !== undefined) {
            const intPart = (targetTemperature).toFixed(1).split(".")[0]
            const realPart = (targetTemperature).toFixed(1).split(".")[1]
            return <div className="target-temp">
                <IconMinus className="button m" onClick={() => { setTargetTemperature(targetTemperature - 0.5) }} />
                <div className="int-part">{intPart}</div>
                <div className="float-part">.{realPart}</div>
                <div className="sign-part"><div>˚</div><div>c</div></div>
                <IconPlus className="button p" onClick={() => { setTargetTemperature(targetTemperature + 0.5) }} />
            </div>;
        } else
            return <div className="target-temp">
                <div className="int-part">—</div>
                <div className="float-part"></div>
                <div className="sign-part"><div>˚</div><div>c</div></div>
            </div>;
    }, [targetTemperature, showTemperatures, setTargetTemperature]);

    const stateSections = [
        {
            key: "thermostat-state-section-mode",
            header: se.mode,
            className: mode_enable ? "section state" : "section state inactive",
            buttons: [
                {
                    key: "thermostat-state-section-mode-0",
                    className: modeState[0] ? "button red" : "button black",
                    onClick: onModeClickH(SednaInfo.mode.heating),
                    icon: modeState[0] ? IconModeHeatingBlack : IconModeHeating,
                    label: se.heating,
                },
                {
                    key: "thermostat-state-section-mode-1",
                    className: modeState[1] ? "button blue" : "button black",
                    onClick: onModeClickH(SednaInfo.mode.cooling),
                    icon: modeState[1] ? IconModeCoolingBlack : IconModeCooling,
                    label: se.cooling,
                },
            ]
        },
        {
            key: "thermostat-state-section-fan",
            header: se.fanSpeed,
            className: motor_speed_enable ? "section state" : "section state inactive",
            buttons: [
                {
                    key: "thermostat-state-section-fan-0",
                    className: motorSpeedState[0] ? "button turquoise" : "button black",
                    onClick: onMotorSpeedClickH(SednaInfo.motorSpeed.high),
                    icon: motorSpeedState[0] ? IconSpeedFastBlack : IconSpeedFast,
                    label: se.fast,
                },
                {
                    key: "thermostat-state-section-fan-1",
                    className: motorSpeedState[1] ? "button turquoise" : "button black",
                    onClick: onMotorSpeedClickH(SednaInfo.motorSpeed.medium),
                    icon: motorSpeedState[1] ? IconSpeedMediumBlack : IconSpeedMedium,
                    label: se.medium,
                },
                {
                    key: "thermostat-state-section-fan-2",
                    className: motorSpeedState[2] ? "button turquoise" : "button black",
                    onClick: onMotorSpeedClickH(SednaInfo.motorSpeed.low),
                    icon: motorSpeedState[2] ? IconSpeedSlowBlack : IconSpeedSlow,
                    label: se.slow,
                },
                {
                    key: "thermostat-state-section-fan-3",
                    className: motorSpeedState[3] ? "button turquoise" : "button black",
                    onClick: onMotorSpeedClickH(SednaInfo.motorSpeed.auto),
                    icon: motorSpeedState[3] ? IconSpeedAutoBlack : IconSpeedAuto,
                    label: se.auto,
                },
            ]
        },
        {
            key: "thermostat-state-section-scene",
            header: se.scene,
            className: scenario_enable ? "section state" : "section state inactive",
            buttons: [
                {
                    key: "thermostat-state-section-scene-0",
                    className: scenarioState[0] ? "button pink" : "button black",
                    onClick: onScenarioClickH(SednaInfo.scenario.turbo),
                    icon: scenarioState[0] ? IconScenarioTurboBlack : IconScenarioTurbo,
                    label: se.turbo,
                },
                {
                    key: "thermostat-state-section-scene-1",
                    className: scenarioState[1] ? "button pink" : "button black",
                    onClick: onScenarioClickH(SednaInfo.scenario.sleep),
                    icon: scenarioState[1] ? IconScenarioSleepBlack : IconScenarioSleep,
                    label: se.sleep,
                },
                {
                    key: "thermostat-state-section-scene-2",
                    className: scenarioState[2] ? "button pink" : "button black",
                    onClick: onScenarioClickH(SednaInfo.scenario.away),
                    icon: scenarioState[2] ? IconScenarioLeaveBlack : IconScenarioLeave,
                    label: se.leave,
                },
                {
                    key: "thermostat-state-section-scene-3",
                    className: scenarioState[3] ? "button pink" : "button black",
                    onClick: onScenarioClickH(SednaInfo.scenario.manual),
                    icon: scenarioState[3] ? IconScenarioManualBlack : IconScenarioManual,
                    label: se.manual,
                },
            ]
        },
    ]

    const innerCircleData = {
        modeIcon: modeState[0] ? IconModeHeating : IconModeCooling,
        modeLabelText: modeState[0] ? se.heating : se.cooling,
        temperature: targetTemperatureToShow,
        bottomIcons: [
            {
                icon: motorSpeedState[0] ? IconSpeedFastGray :
                    motorSpeedState[1] ? IconSpeedMediumGray :
                        motorSpeedState[2] ? IconSpeedSlowGray :
                            IconSpeedAutoGray,
                key: "thermostat-inner-circle-motor-speed",
                className: "icon"
            },
            {
                icon: scenarioState[0] ? IconScenarioTurboGray :
                    scenarioState[1] ? IconScenarioSleepGray :
                        scenarioState[2] ? IconScenarioLeaveGray :
                            IconScenarioManualGray,
                key: "thermostat-inner-circle-scenario",
                className: "icon"
            }
        ]
    }
    if (device.is_economy) {
        innerCircleData.bottomIcons.splice(1, 0, {
            icon: IconSednaEconomyGray,
            key: "thermostat-inner-circle-economy",
            className: "icon"
        });
    }


    const isTransparent = device.active && (!device.is_on || !device.set_point_enable);
    const canEdit = device.active && device.is_on && device.set_point_enable;

    const currentTemperature = device.temperature;

    return [
        currentTemperature, targetTemperature,
        setTargetTemperature, setTempTargetTemperature,
        showTemperatures, showSetpoint, isTransparent, canEdit,
        innerCircleData, stateSections,
    ]
}

function useHinavaEcoThermostat(device) {
    const het = useLocalizedStrings().hinavaEcoThermostat;

    const modeState = [
        device.mode_setting === HinavaEcoThermostatInfo.mode.heating,
        device.mode_setting === HinavaEcoThermostatInfo.mode.cooling
    ]
    if (device.has_fan_mode) {
        modeState.push(device.mode_setting === HinavaEcoThermostatInfo.mode.fan)
    }
    const fanSpeedSetting = [
        device.fan_setting === HinavaEcoThermostatInfo.fanSetting.high,
        device.fan_setting === HinavaEcoThermostatInfo.fanSetting.medium,
        device.fan_setting === HinavaEcoThermostatInfo.fanSetting.low,
        device.fan_setting === HinavaEcoThermostatInfo.fanSetting.auto,
    ]
    const fanSpeedStatus = [
        device.fan_status === HinavaEcoThermostatInfo.fanStatus.high,
        device.fan_status === HinavaEcoThermostatInfo.fanStatus.medium,
        device.fan_status === HinavaEcoThermostatInfo.fanStatus.low,
        device.fan_status === HinavaEcoThermostatInfo.fanStatus.off,
    ]

    const onModeClickH = useCallback((mode) => {
        return (event) => {
            event.preventDefault();
            if (device.is_on && device.active)
                device.changeState({ mode_setting: mode });
        }
    }, [device]);

    const onFanSettingClickH = useCallback((fan) => {
        return (event) => {
            event.preventDefault();
            if (device.is_on && device.active)
                device.changeState({ fan_setting: fan });
        }
    }, [device]);

    const onTurboClickH = useCallback((on) => {
        return (event) => {
            event.preventDefault();
            if (device.is_on && device.active)
                device.changeState({ turbo_setting: on });
        }
    }, [device]);

    const [targetTemperature, setTempTargetTemperature] = useState(device.set_point);
    useEffect(() => {
        setTempTargetTemperature(device.set_point);
    }, [device.set_point]);
    const setTargetTemperature = useCallback((v) => {
        let newValue = Number(v.toFixed(1));
        if ((device.set_point_min !== undefined) && (device.set_point_max !== undefined)) {
            newValue = Math.max(device.set_point_min, Math.min(device.set_point_max, newValue));
        }
        setTempTargetTemperature(newValue);
        device.changeState({ set_point: newValue });
    }, [device]);

    const showTemperatures = device.active && device.is_on;
    const showSetpoint = showTemperatures && (device.mode_setting !== HinavaEcoThermostatInfo.mode.fan);
    const targetTemperatureToShow = useMemo(() => {
        if (showSetpoint && targetTemperature !== undefined) {
            const intPart = (targetTemperature).toFixed(1).split(".")[0]
            const realPart = (targetTemperature).toFixed(1).split(".")[1]
            return <div className="target-temp">
                <IconMinus className="button m" onClick={() => { setTargetTemperature(targetTemperature - 0.5) }} />
                <div className="int-part">{intPart}</div>
                <div className="float-part">.{realPart}</div>
                <div className="sign-part"><div>˚</div><div>c</div></div>
                <IconPlus className="button p" onClick={() => { setTargetTemperature(targetTemperature + 0.5) }} />
            </div>;
        } else
            return <div className="target-temp">
                <div className="int-part">—</div>
                <div className="float-part"></div>
                <div className="sign-part"><div>˚</div><div>c</div></div>
            </div>;
    }, [targetTemperature, showSetpoint, setTargetTemperature]);

    const stateSections = [
        {
            key: "thermostat-state-section-mode",
            header: het.mode,
            className: device.is_on && device.active ? "section state" : "section state inactive",
            buttons: [
                {
                    key: "thermostat-state-section-mode-0",
                    className: modeState[0] ? "button red" : "button black",
                    onClick: onModeClickH(HinavaEcoThermostatInfo.mode.heating),
                    icon: modeState[0] ? IconModeHeatingBlack : IconModeHeating,
                    label: het.heating,
                },
                {
                    key: "thermostat-state-section-mode-1",
                    className: modeState[1] ? "button blue" : "button black",
                    onClick: onModeClickH(HinavaEcoThermostatInfo.mode.cooling),
                    icon: modeState[1] ? IconModeCoolingBlack : IconModeCooling,
                    label: het.cooling,
                },
            ].concat(
                device.has_fan_mode ? [
                    {
                        key: "thermostat-state-section-mode-2",
                        className: modeState[2] ? "button white" : "button black",
                        onClick: onModeClickH(HinavaEcoThermostatInfo.mode.fan),
                        icon: modeState[2] ? IconModeFanBlack : IconModeFan,
                        label: het.fan,
                    },
                ] : []
            )
        },
        {
            key: "thermostat-state-section-fan",
            header: het.fanSpeed,
            className: device.is_on && device.active ? "section state" : "section state inactive",
            buttons: [
                {
                    key: "thermostat-state-section-fan-0",
                    className: fanSpeedSetting[0] ? "button turquoise" : "button black",
                    onClick: onFanSettingClickH(HinavaEcoThermostatInfo.fanSetting.high),
                    icon: fanSpeedSetting[0] ? IconSpeedFastBlack : IconSpeedFast,
                    label: het.fast,
                },
                {
                    key: "thermostat-state-section-fan-1",
                    className: fanSpeedSetting[1] ? "button turquoise" : "button black",
                    onClick: onFanSettingClickH(HinavaEcoThermostatInfo.fanSetting.medium),
                    icon: fanSpeedSetting[1] ? IconSpeedMediumBlack : IconSpeedMedium,
                    label: het.medium,
                },
                {
                    key: "thermostat-state-section-fan-2",
                    className: fanSpeedSetting[2] ? "button turquoise" : "button black",
                    onClick: onFanSettingClickH(HinavaEcoThermostatInfo.fanSetting.low),
                    icon: fanSpeedSetting[2] ? IconSpeedSlowBlack : IconSpeedSlow,
                    label: het.slow,
                }
            ].concat(
                (device.mode_setting === HinavaEcoThermostatInfo.mode.fan) ? [] : [
                    {
                        key: "thermostat-state-section-fan-3",
                        className: fanSpeedSetting[3] ? "button turquoise" : "button black",
                        onClick: onFanSettingClickH(HinavaEcoThermostatInfo.fanSetting.auto),
                        icon: fanSpeedSetting[3] ? IconSpeedAutoBlack : IconSpeedAuto,
                        label: het.auto,
                    }
                ]
            )
        },
        {
            key: "thermostat-state-section-scene",
            header: het.turboHeader,
            className: device.is_on && device.active ? "section state" : "section state inactive",
            buttons: [
                {
                    key: "thermostat-state-section-scene-0",
                    className: device.turbo_setting ? "button pink" : "button black",
                    onClick: onTurboClickH(true),
                    icon: device.turbo_setting ? IconHinavaTurboBlack : IconHinavaTurbo,
                    label: het.turbo,
                },
                {
                    key: "thermostat-state-section-scene-3",
                    className: (!device.turbo_setting) ? "button pink" : "button black",
                    onClick: onTurboClickH(false),
                    icon: (!device.turbo_setting) ? IconScenarioManualBlack : IconScenarioManual,
                    label: het.manual,
                },
            ]
        },
    ]

    const innerCircleData = {
        modeIcon: modeState[0] ? IconModeHeating : (modeState[1] ? IconModeCooling : IconModeFan),
        modeLabelText: modeState[0] ? het.heating : (modeState[1] ? het.cooling : het.fan),
        temperature: targetTemperatureToShow,
        bottomIcons: []
    }
    if (device.fan_status !== undefined) {
        innerCircleData.bottomIcons.push({
            icon: fanSpeedStatus[0] ? IconSpeedFastGray :
                fanSpeedStatus[1] ? IconSpeedMediumGray :
                    fanSpeedStatus[2] ? IconSpeedSlowGray :
                        IconSpeedOffGray,
            key: "thermostat-inner-circle-motor-speed",
            className: "icon"
        })
    }
    if (device.is_economy) {
        innerCircleData.bottomIcons.push({
            icon: IconHinavaEconomyGray,
            key: "thermostat-inner-circle-economy",
            className: "icon"
        });
    }
    if (device.turbo_setting) {
        innerCircleData.bottomIcons.push({
            icon: IconHinavaTurboGray,
            key: "thermostat-inner-circle-scenario",
            className: "icon"
        })
    }

    const isTransparent = device.active && (!device.is_on);
    const canEdit = device.active && device.is_on && (device.mode_setting !== HinavaEcoThermostatInfo.mode.fan);

    const currentTemperature = device.env_temperature;

    return [
        currentTemperature, targetTemperature,
        setTargetTemperature, setTempTargetTemperature,
        showTemperatures, showSetpoint, isTransparent, canEdit, 
        innerCircleData, stateSections,
    ]
}


function useMarsus(device) {

    //#region useCallback
    const onModeClickH = useCallback((mode) => {
        return (event) => {
            event.preventDefault();
            if (device.is_on && device.active)
                device.changeState({ mode: mode, sub_type: device.sub_type });
        }
    }, [device]);

    const onFanSpeedClickH = useCallback((fanSpeed) => {
        return (event) => {
            event.preventDefault();
            if (device.is_on && device.active)
                device.changeState({ fan_speed: fanSpeed, sub_type: device.sub_type });
        }
    }, [device]);

    const onPumpClickH = useCallback((pump) => {
        return (event) => {
            event.preventDefault();
            if (device.is_on && device.active)
                device.changeState({ pump: pump, sub_type: device.sub_type });
        }
    }, [device]);

    const [targetTemperature, setTempTargetTemperature] = useState(device.set_point);
    useEffect(() => {
        setTempTargetTemperature(device.set_point);
    }, [device.set_point]);
    const setTargetTemperature = useCallback((v) => {
        let newValue = Number(v.toFixed(1));
        if ((device.set_point_min !== undefined) && (device.set_point_max !== undefined)) {
            newValue = Math.max(device.set_point_min, Math.min(device.set_point_max, newValue));
        }
        setTempTargetTemperature(newValue);
        device.changeState({ set_point: newValue, sub_type: device.sub_type });
    }, [device]);
    //#endregion

    const sm = useLocalizedStrings().marsus;

    const showTemperatures = device.active && device.is_on;
    const showSetpoint = showTemperatures;
    const targetTemperatureToShow = useMemo(() => {
        if (showTemperatures && targetTemperature !== undefined) {
            const intPart = (targetTemperature).toFixed(1).split(".")[0]
            const realPart = (targetTemperature).toFixed(1).split(".")[1]
            return <div className="target-temp">
                <IconMinus className="button m" onClick={() => { setTargetTemperature(targetTemperature - 0.5) }} />
                <div className="int-part">{intPart}</div>
                <div className="float-part">.{realPart}</div>
                <div className="sign-part"><div>˚</div><div>c</div></div>
                <IconPlus className="button p" onClick={() => { setTargetTemperature(targetTemperature + 0.5) }} />
            </div>;
        } else
            return <div className="target-temp">
                <div className="int-part">—</div>
                <div className="float-part"></div>
                <div className="sign-part"><div>˚</div><div>c</div></div>
            </div>;
    }, [targetTemperature, showTemperatures, setTargetTemperature]);

    let modeState, fanSpeedState, pumpState, setPointEnable, stateSections, innerCircleData;

    switch (device.sub_type) {
        case MarsusInfo.subType.fanCoil:
            modeState = [
                device.mode === MarsusInfo.fanCoil.mode.heat,
                device.mode === MarsusInfo.fanCoil.mode.cool,
            ];
            fanSpeedState = [
                device.fan_speed === MarsusInfo.fanCoil.fanSpeed.fast,
                device.fan_speed === MarsusInfo.fanCoil.fanSpeed.medium,
                device.fan_speed === MarsusInfo.fanCoil.fanSpeed.slow,
                device.fan_speed === MarsusInfo.fanCoil.fanSpeed.auto,
            ];
            stateSections = [
                {
                    key: "thermostat-state-section-mode",
                    header: sm.mode.title,
                    className: device.is_on && device.active ? "section state" : "section state inactive",
                    buttons: [
                        {
                            key: "thermostat-state-section-mode-0",
                            className: modeState[0] ? "button red" : "button black",
                            onClick: onModeClickH(MarsusInfo.fanCoil.mode.heat),
                            icon: modeState[0] ? IconModeHeatingBlack : IconModeHeating,
                            label: sm.mode.heat,
                        },
                        {
                            key: "thermostat-state-section-mode-1",
                            className: modeState[1] ? "button blue" : "button black",
                            onClick: onModeClickH(MarsusInfo.fanCoil.mode.cool),
                            icon: modeState[1] ? IconModeCoolingBlack : IconModeCooling,
                            label: sm.mode.cool,
                        },
                    ]
                },
                {
                    key: "thermostat-state-section-fan",
                    header: sm.fanSpeed.title,
                    className: device.is_on && device.active ? "section state" : "section state inactive",
                    buttons: [
                        {
                            key: "thermostat-state-section-fan-0",
                            className: fanSpeedState[0] ? "button turquoise" : "button black",
                            onClick: onFanSpeedClickH(MarsusInfo.fanCoil.fanSpeed.fast),
                            icon: fanSpeedState[0] ? IconSpeedFastBlack : IconSpeedFast,
                            label: sm.fanSpeed.fast,
                        },
                        {
                            key: "thermostat-state-section-fan-1",
                            className: fanSpeedState[1] ? "button turquoise" : "button black",
                            onClick: onFanSpeedClickH(MarsusInfo.fanCoil.fanSpeed.medium),
                            icon: fanSpeedState[1] ? IconSpeedMediumBlack : IconSpeedMedium,
                            label: sm.fanSpeed.medium,
                        },
                        {
                            key: "thermostat-state-section-fan-2",
                            className: fanSpeedState[2] ? "button turquoise" : "button black",
                            onClick: onFanSpeedClickH(MarsusInfo.fanCoil.fanSpeed.slow),
                            icon: fanSpeedState[2] ? IconSpeedSlowBlack : IconSpeedSlow,
                            label: sm.fanSpeed.slow,
                        },
                        {
                            key: "thermostat-state-section-fan-3",
                            className: fanSpeedState[3] ? "button turquoise" : "button black",
                            onClick: onFanSpeedClickH(MarsusInfo.fanCoil.fanSpeed.auto),
                            icon: fanSpeedState[3] ? IconSpeedAutoBlack : IconSpeedAuto,
                            label: sm.fanSpeed.auto,
                        },
                    ]
                },
            ];
            innerCircleData = {
                modeIcon: modeState[0] ? IconModeHeating : IconModeCooling,
                modeLabelText: modeState[0] ? sm.mode.heat : sm.mode.cool,
                temperature: targetTemperatureToShow,
                bottomIcons: [
                    {
                        icon:
                            fanSpeedState[0] ? IconSpeedFastGray :
                                fanSpeedState[1] ? IconSpeedMediumGray :
                                    fanSpeedState[2] ? IconSpeedSlowGray :
                                        IconSpeedAutoGray,
                        key: "thermostat-inner-circle-motor-speed",
                        className: "icon"
                    }
                ]
            };
            setPointEnable = true;
            break;
        // --------------------------------------------------------------------
        case MarsusInfo.subType.package:
            modeState = [
                device.mode === MarsusInfo.package.mode.normal,
                device.mode === MarsusInfo.package.mode.eco,
                device.mode === MarsusInfo.package.mode.antiFreeze,
            ]
            stateSections = [
                {
                    key: "thermostat-state-section-mode",
                    header: sm.mode.title,
                    className: device.is_on && device.active ? "section state" : "section state inactive",
                    buttons: [
                        {
                            key: "thermostat-state-section-mode-0",
                            className: modeState[0] ? "button red" : "button black",
                            onClick: onModeClickH(MarsusInfo.package.mode.normal),
                            icon: modeState[0] ? IconModeHeatingBlack : IconModeHeating,
                            label: sm.mode.normal,
                        },
                        {
                            key: "thermostat-state-section-mode-1",
                            className: modeState[1] ? "button grass" : "button black",
                            onClick: onModeClickH(MarsusInfo.package.mode.eco),
                            icon: modeState[1] ? IconModeEcoBlack : IconModeEco,
                            label: sm.mode.eco,
                        },
                        {
                            key: "thermostat-state-section-mode-2",
                            className: modeState[2] ? "button yellow" : "button black",
                            onClick: onModeClickH(MarsusInfo.package.mode.antiFreeze),
                            icon: modeState[2] ? IconModeAntiFreezeBlack : IconModeAntiFreeze,
                            label: sm.mode.antiFreeze,
                        },
                    ]
                },
            ];
            innerCircleData = {
                modeIcon:
                    modeState[0] ? IconModeHeating :
                        modeState[1] ? IconModeEco : IconModeAntiFreeze,
                modeLabelText:
                    modeState[0] ? sm.mode.normal :
                        modeState[1] ? sm.mode.eco : sm.mode.antiFreeze,
                temperature: targetTemperatureToShow,
                bottomIcons: []
            };
            setPointEnable = modeState[0];
            break;
        // --------------------------------------------------------------------
        case MarsusInfo.subType.cooler:
            modeState = [
                device.mode === MarsusInfo.cooler.mode.manual,
                device.mode === MarsusInfo.cooler.mode.auto,
            ]
            fanSpeedState = [
                device.fan_speed === MarsusInfo.cooler.fanSpeed.fast,
                device.fan_speed === MarsusInfo.cooler.fanSpeed.medium,
                device.fan_speed === MarsusInfo.cooler.fanSpeed.off,
            ]
            pumpState = [
                device.pump,
                !device.pump,
            ]
            stateSections = [
                {
                    key: "thermostat-state-section-mode",
                    header: sm.mode.title,
                    className: device.is_on && device.active ? "section state" : "section state inactive",
                    buttons: [
                        {
                            key: "thermostat-state-section-mode-0",
                            className: modeState[0] ? "button pink" : "button black",
                            onClick: onModeClickH(MarsusInfo.cooler.mode.manual),
                            icon: modeState[0] ? IconModeManualBlack : IconModeManual,
                            label: sm.mode.manual,
                        },
                        {
                            key: "thermostat-state-section-mode-1",
                            className: modeState[1] ? "button pink" : "button black",
                            onClick: onModeClickH(MarsusInfo.cooler.mode.auto),
                            icon: modeState[1] ? IconModeAutoBlack : IconModeAuto,
                            label: sm.mode.auto,
                        },
                    ]
                },
                {
                    key: "thermostat-state-section-fan",
                    header: sm.fanSpeed.title,
                    className: device.is_on && device.active ? "section state" : "section state inactive",
                    buttons: [
                        {
                            key: "thermostat-state-section-fan-0",
                            className: fanSpeedState[0] ? "button turquoise" : "button black",
                            onClick: onFanSpeedClickH(MarsusInfo.cooler.fanSpeed.fast),
                            icon: fanSpeedState[0] ? IconSpeedFastBlack : IconSpeedFast,
                            label: sm.fanSpeed.fast,
                        },
                        {
                            key: "thermostat-state-section-fan-1",
                            className: fanSpeedState[1] ? "button turquoise" : "button black",
                            onClick: onFanSpeedClickH(MarsusInfo.cooler.fanSpeed.medium),
                            icon: fanSpeedState[1] ? IconSpeedSlowBlack : IconSpeedSlow,
                            label: sm.fanSpeed.slow,
                        },
                        {
                            key: "thermostat-state-section-fan-2",
                            className: fanSpeedState[2] ? "button turquoise" : "button black",
                            onClick: onFanSpeedClickH(MarsusInfo.cooler.fanSpeed.off),
                            icon: fanSpeedState[2] ? IconSpeedOffBlack : IconSpeedOff,
                            label: sm.fanSpeed.off,
                        },
                    ]
                },
                {
                    key: "thermostat-state-section-pump",
                    header: sm.pump.title,
                    className: device.is_on && device.active ? "section state" : "section state inactive",
                    buttons: [
                        {
                            key: "thermostat-state-section-pump-0",
                            className: pumpState[0] ? "button blue" : "button black",
                            onClick: onPumpClickH(true),
                            icon: pumpState[0] ? IconPumpOnBlack : IconPumpOn,
                            label: sm.pump.on,
                        },
                        {
                            key: "thermostat-state-section-pump-1",
                            className: pumpState[1] ? "button blue" : "button black",
                            onClick: onPumpClickH(false),
                            icon: pumpState[1] ? IconPumpOffBlack : IconPumpOff,
                            label: sm.pump.off,
                        },
                    ]
                },
            ];
            innerCircleData = {
                modeIcon:
                    modeState[0] ? IconModeManual : IconModeAuto,
                modeLabelText:
                    modeState[0] ? sm.mode.manual : sm.mode.auto,
                temperature: targetTemperatureToShow,
                bottomIcons: [
                    {
                        icon:
                            fanSpeedState[0] ? IconSpeedFastGray :
                                fanSpeedState[1] ? IconSpeedSlowGray :
                                    IconSpeedOffGray,
                        key: "thermostat-inner-circle-motor-speed",
                        className: "icon"
                    },
                    {
                        icon:
                            pumpState[0] ? IconPumpOnGray :
                                IconPumpOffGray,
                        key: "thermostat-inner-circle-pump",
                        className: "icon"
                    },
                ]
            };
            setPointEnable = true;
            break;
        default:
            break;
    }

    const isTransparent = device.active && (!device.is_on || !setPointEnable);
    const canEdit = device.active && device.is_on && setPointEnable;

    const currentTemperature = device.temperature;

    return [
        currentTemperature, targetTemperature,
        setTargetTemperature, setTempTargetTemperature,
        showTemperatures, showSetpoint, isTransparent, canEdit,
        innerCircleData, stateSections,
    ]
}

export function SednaControl({ device, forLightBackground }) {
    const [
        currentTemperature, targetTemperature,
        setTargetTemperature, setTempTargetTemperature,
        showTemperatures, showSetpoint, isTransparent, canEdit,
        innerCircleData, stateSections,
    ] = useSedna(device);

    return React.createElement(ThermostatControl, {
        device,
        currentTemperature, targetTemperature,
        setTargetTemperature, setTempTargetTemperature,
        shouldRoundHalfTargetTemperature: false,
        showTemperatures, showSetpoint, isTransparent, canEdit,
        innerCircleData, stateSections,
        forLightBackground,
    });
}

export function EcoThermostatControl({ device, forLightBackground }) {
    const [
        currentTemperature, targetTemperature,
        setTargetTemperature, setTempTargetTemperature,
        showTemperatures, showSetpoint, isTransparent, canEdit,
        innerCircleData, stateSections,
    ] = useHinavaEcoThermostat(device);

    return React.createElement(ThermostatControl, {
        device,
        currentTemperature, targetTemperature,
        setTargetTemperature, setTempTargetTemperature,
        shouldRoundHalfTargetTemperature: true,
        showTemperatures, showSetpoint, isTransparent, canEdit,
        innerCircleData, stateSections,
        forLightBackground,
    });
}

export function MarsusControl({ device, forLightBackground }) {
    const [
        currentTemperature, targetTemperature,
        setTargetTemperature, setTempTargetTemperature,
        showTemperatures, showSetpoint, isTransparent, canEdit,
        innerCircleData, stateSections,
    ] = useMarsus(device);

    return React.createElement(ThermostatControl, {
        device,
        currentTemperature, targetTemperature,
        setTargetTemperature, setTempTargetTemperature,
        shouldRoundHalfTargetTemperature: false,
        showTemperatures, showSetpoint, isTransparent, canEdit,
        innerCircleData, stateSections,
        forLightBackground,
    });
}

function ThermostatControl({
    device,
    currentTemperature, targetTemperature,
    setTargetTemperature, setTempTargetTemperature,
    shouldRoundHalfTargetTemperature,
    showTemperatures, showSetpoint, isTransparent, canEdit,
    innerCircleData, stateSections,
    forLightBackground }) {
    const s = useLocalizedStrings();
    return (
        <div className="thermostat-control-container">
            <div className="section wheel">
                <ThermostatWheel componentName="thermostat-wheel-on-detail"
                    minTargetTemperature={device.set_point_min} maxTargetTemperature={device.set_point_max}
                    currentTemperature={currentTemperature}

                    targetTemperature={targetTemperature}
                    setTargetTemperature={setTargetTemperature}
                    setTempTargetTemperature={setTempTargetTemperature}
                    shouldRoundHalfTargetTemperature={shouldRoundHalfTargetTemperature}

                    canEdit={canEdit}
                    showTemperatures={showTemperatures}
                    showSetpoint={showSetpoint}
                    isTransparent={isTransparent}
                    isDisconnected={!device.active}

                    forLightBackground={forLightBackground}>

                    {/* whatever is inside the main circle */}
                    <div className="thermostat-wheel-data">
                        <div className="mode">
                            {
                                React.createElement(innerCircleData.modeIcon, { className: "mode-icon" })
                            }
                            <div className="mode-label">{innerCircleData.modeLabelText}</div>
                        </div>
                        {innerCircleData.temperature}
                        <div className="icon-group">
                            {
                                innerCircleData.bottomIcons.map(iconData =>
                                    React.createElement(iconData.icon, { className: iconData.className, key: iconData.key })
                                )
                            }
                        </div>
                    </div>
                </ThermostatWheel>
            </div>
            {(!device.is_on && device.active) ? <div className={forLightBackground ? "off-info black" : "off-info"}>
                <div className="text">{s.thermostatOff.title}</div>
                <div className="button" onClick={() => { device.changeState({ is_on: true }) }}>
                    <div className="text">{s.thermostatOff.button}</div>
                    {forLightBackground ? <IconOnWhite className="icon" /> : <IconOnBlack className="icon" />}
                </div>
            </div> : null}
            {
                stateSections.map(section => (
                    <div className={section.className} key={section.key}>
                        <div className={forLightBackground ? "header black" : "header"}>{section.header}</div>
                        <div className="buttons">
                            {
                                section.buttons.map(button => (
                                    <div
                                        key={button.key}
                                        className={button.className}
                                        onClick={button.onClick}>
                                        {
                                            React.createElement(button.icon, { className: "icon" })
                                        }
                                        <div className="label">{button.label}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                ))
            }
        </div>
    );
}
